import { createGlobalStyle } from 'styled-components';

export const ButtonTooltipsGlobalStyle = createGlobalStyle`
  body {
    .button-icon-tooltip.ant-tooltip {
      /* &.ant-tooltip-hidden {
        display: block;
      } */
      // Modificato la posizione del tootip
      // per avvicinarlo all'icona
      &.ant-tooltip-placement-top,
      &.ant-tooltip-placement-topLeft,
      &.ant-tooltip-placement-topRight {
        .ant-tooltip-content {
          padding-top: 15px;
          margin-bottom: -15px;
        }
        .ant-tooltip-arrow {
          margin-bottom: -15px;
        }
      }
      &.ant-tooltip-placement-bottom,
      &.ant-tooltip-placement-bottomLeft,
      &.ant-tooltip-placement-bottomRight {
        .ant-tooltip-content {
          padding-bottom: 15px;
          margin-top: -15px;
        }
        .ant-tooltip-arrow {
          margin-top: -15px;
        }

      }
      &.ant-tooltip-placement-left
      &.ant-tooltip-placement-leftTop,
      &.ant-tooltip-placement-leftBottom {
        .ant-tooltip-content {
          padding-left: 15px;
          margin-right: -15px;
        }
        .ant-tooltip-arrow {
          margin-right: -15px;
        }
      }
      &.ant-tooltip-placement-right
      &.ant-tooltip-placement-rightTop,
      &.ant-tooltip-placement-rightBottom {
        .ant-tooltip-content {
          padding-right: 15px;
          margin-left: -15px;
        }
        .ant-tooltip-arrow {
          margin-left: -15px;
        }
      }
    }
  }
`;
